"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var PersonalInfo = function () {
    var t = (0, react_i18next_1.useTranslation)("en").t;
    return react_1["default"].createElement("div", { className: "PersonalInfo" },
        react_1["default"].createElement("p", null,
            react_1["default"].createElement("u", null, t('personalInfo'))),
        react_1["default"].createElement("p", null, t('linguae')),
        react_1["default"].createElement("p", null, t('hobbies')),
        react_1["default"].createElement("p", null, t('email')),
        react_1["default"].createElement("p", null, t('address')),
        react_1["default"].createElement("p", null,
            t('phone'),
            " : ",
            react_1["default"].createElement("img", { src: "images/belgium.gif", height: 20 }),
            "+32474907234",
            react_1["default"].createElement("br", null),
            react_1["default"].createElement("span", { className: "offseted" },
                react_1["default"].createElement("img", { src: "images/canada.gif", height: 20 }),
                "+1 (437)660-4752"),
            react_1["default"].createElement("br", null),
            react_1["default"].createElement("span", { className: "offseted" },
                react_1["default"].createElement("img", { src: "images/uk.gif", height: 20 }),
                "+447774178415")));
};
exports["default"] = PersonalInfo;
